// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlarmTooltip--row--VNj_L {
  line-height: 16px;
  max-width: 200px;
  min-width: 100px;
  font-weight: 500;
  color: var(--stat--default);
  text-align: center;
}

.AlarmTooltip--time--MeLbt {
  font-weight: 400;
  margin-bottom: 6px;
}

.AlarmTooltip--deviceAlarmTitle--TsYfw {
  font-weight: 900;
}

.AlarmTooltip--alarmType--TWFLP {
}
`, "",{"version":3,"sources":["webpack://./src/components/daily/alarmtooltip/AlarmTooltip.css"],"names":[],"mappings":"AAAA;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;AAEA","sourcesContent":[".row {\n  composes: smallSize from '../../../styles/typography.css';\n  line-height: 16px;\n  max-width: 200px;\n  min-width: 100px;\n  font-weight: 500;\n  color: var(--stat--default);\n  text-align: center;\n}\n\n.time {\n  composes: row;\n  font-weight: 400;\n  margin-bottom: 6px;\n}\n\n.deviceAlarmTitle {\n  composes: row;\n  font-weight: 900;\n}\n\n.alarmType {\n  composes: row;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `AlarmTooltip--row--VNj_L ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"time": `AlarmTooltip--time--MeLbt AlarmTooltip--row--VNj_L ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"deviceAlarmTitle": `AlarmTooltip--deviceAlarmTitle--TsYfw AlarmTooltip--row--VNj_L ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"alarmType": `AlarmTooltip--alarmType--TWFLP AlarmTooltip--row--VNj_L ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`
};
export default ___CSS_LOADER_EXPORT___;
